/*
* Common functions for all pages
*/
'use strict';

const WAITING_TEXT = 'Минуту...';

let g = {
	dynamicRendered: false,
	favourites: [],
	compares: []
};

/*
* captchas
*/
var onloadRecaptcha = function() {
	const captchas = document.querySelectorAll('.js-recaptcha');
	captchas.forEach(captchaEl => {
		grecaptcha.render(captchaEl, {'sitekey': '6Le-zyYUAAAAACGZmiOU7DFdc4UtaYWQIBDnXKiV'});
	});
}

function setCookie(name, value, options) {
	options = options || {};

	var expires = options.expires;

	if (typeof expires == "number" && expires) {
		var d = new Date();
		d.setTime(d.getTime() + expires * 1000);
		expires = options.expires = d;
	}
	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	value = encodeURIComponent(value);

	var updatedCookie = name + "=" + value;

	for (var propName in options) {
		updatedCookie += "; " + propName;
		var propValue = options[propName];
		if (propValue !== true) {
			updatedCookie += "=" + propValue;
		}
	}

	document.cookie = updatedCookie;
}

function getCookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

function isScrolledIntoView(el) {
	var rect = el.getBoundingClientRect();
	var elemTop = rect.top;
	var elemBottom = rect.bottom;
	var isVisible;

	// Only completely visible elements return true:
	// isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
	// Partially visible elements return true:
	isVisible = elemTop < window.innerHeight && elemBottom >= 0;
	return isVisible;
}

function regular(string) {
	if (!string) return "";
	var Chars = "0123456789.,/\-";
	var news = "";

	for (var i = 0; i < string.length; i++) {
			if (Chars.indexOf(string.charAt(i)) == -1) {
					void (null);
			} else {
					news = news + string.charAt(i);
			}
	}
	return news;
}

function setFavourites() {
	g.favourites.forEach( favId => {
		const favParents = document.querySelectorAll('[data-add-to-fav]');
		favParents.forEach( parent => {
			if (parent.dataset.id = favId) {
				parent.classList.add('active');

				let label = favBtn.querySelector('[data-success]');
				if (label) {
					[favBtn.querySelector('.icon-btn__name').textContent] = [label.dataset.success];
				}
			}
		});
	});
}

function initFavourites(count) {
	
	// draw favourite count
	const fav = document.querySelector('.h__btn--fav');

	const label = document.createElement('span');
	label.classList.add('h__btn-label');
	label.dataset.count = count;
	label.textContent = count;
	fav.appendChild(label);

	if (g.dynamicRendered) {
		setFavourites();
	}
}

function initCompare(count) {
	
	// draw favourite count
	const compare = document.querySelector('.h__btn--compare');

	const label = document.createElement('span');
	label.classList.add('h__btn-label');
	label.dataset.count = count;
	label.textContent = count;
	compare.appendChild(label);
}

function isLogged(data) {

	const profileWrp = document.querySelector('.h__profile-wrp'),
				loginBtn = profileWrp.querySelector('.h__login-btn');
	loginBtn.remove();
	profileWrp.insertAdjacentHTML('beforeend', data.profileBtn);

	document.querySelector('.h__login-link').addEventListener('click', function(){
		profileWrp.classList.add('h__profile-wrp--opened');
	});

	document.addEventListener('click', function(e){
		if (!e.target.closest('.h__profile-wrp')) {
			const opened = document.querySelector('.h__profile-wrp');
			if (opened) {
				opened.classList.remove('h__profile-wrp--opened');
			}
		}
	});
	
	document.querySelector('.mm__login-btn').closest('.mm__line').remove();
	document.querySelector('.mm__logged-part').insertAdjacentHTML('beforeend', data.xsMenuLinks);

	if (data.logoutForm) {
		document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', data.logoutForm);
	}
}

function checkLogin() {
	
	// temp for new header adding
	// let isNewHeader = document.querySelector('.h--update') ? true : false;

	// fetch('/data/checkLogin-old.json', {
	fetch('https://api.restate.ru/auth/checkLogin.json', {
	// fetch('https://api.restate.ru/auth/checkLogin.json', {
		method: 'post',
		// body: 'new-header='+isNewHeader,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
		},
		credentials: 'include'
	}).then(response => {
		return response.json();
	}).then(json => {
		
		if (json.login) {
			isLogged(json.data);
		}

		if (json.data.favouriteCount) {
			g.favourites = json.data.favourites;
			initFavourites(json.data.favouriteCount);
		}

		if (json.data.compareCount) {
			g.compare = json.data.compareCount;
			initCompare(json.data.compareCount);
		}
	});
}

function sendHint(url) {
	// Счетчик яндекса
	if (typeof ym !== "undefined") {
		ym(18881956, 'hit', url);
	}
}

document.addEventListener('DOMContentLoaded', function(){

	checkLogin();
	
	const header = document.querySelector('.h'),
				mobileMenu = document.querySelector('.h__mobile-menu'),
				burgerOpen = document.querySelector('.h__burger'),
				burgerClose = document.querySelectorAll('.mm__close-btn, [data-close-mm]'),
				checkListInputs = document.querySelectorAll('.checklist__input'),
				
				searchPanel = document.querySelector('.slp-form'),
				openSearchPanelBtn = document.querySelector('.h__sl-toolbar-item--search-panel'),
				closeSearchPanelBtn = document.querySelector('.slp-form__close-btn');


	// function stickFunc() {

	// 	sticky = header.offsetTop;

	// 	let st = window.pageYOffset;

	// 	if (st > lastScrollTop){

	// 		// Scroll Down
	// 		sticky += header.clientHeight;

	// 		header.classList.add('h--nav-down')
	// 		header.classList.remove('h--nav-up');
	// 	} else {

	// 		// Scroll Up
	// 		header.classList.add('h--nav-up')
	// 		header.classList.remove('h--nav-down');
	// 	}
	// 	lastScrollTop = st;

	// 	if (window.pageYOffset >= sticky) {

	// 		if (!isScrolledIntoView(header)) {
	// 			header.classList.add('h--sticky');
	// 		}
	// 	} else {
	// 		header.classList.remove('h--sticky');
	// 	}
	// }

	/*
	* Toggle mobile menu
	*/	
	burgerOpen.addEventListener('click', function(){		
		mobileMenu.classList.add('h__mobile-menu--opened');
		document.body.style.overflow = 'hidden';
	});

	burgerClose.forEach(function(item){		
		item.addEventListener('click', function(){			
			mobileMenu.classList.remove('h__mobile-menu--opened');
			document.body.style.overflow = '';
		});
	});


	/*
	* sticky mobile header while scrolling
	*/
	let lastScrollTop = 0,
			sticky = 0;
	// if (header){
	// 	window.onscroll = function() {
	// 		requestAnimationFrame(stickFunc)
	// 	};
	// }

	// search panel on mobile
	if (openSearchPanelBtn) {
		function closeSearchPanel() {
			searchPanel.classList.remove('slp-form--active');
			document.body.style.overflow = '';
		}

		openSearchPanelBtn.addEventListener('click', function(){
			searchPanel.classList.add('slp-form--active');
			document.body.style.overflow = 'hidden';
		});

		closeSearchPanelBtn.addEventListener('click', function(){
			closeSearchPanel();
		});
	}

	// login
	let loginForm = document.querySelector('.js-login-form');

	if (loginForm) {
		let submitBtn = loginForm.querySelector('.login__line-submit'),
				requireElements = loginForm.querySelectorAll('input[required]'),
				oemBtnState = submitBtn.textContent;
					
		loginForm.addEventListener('submit', function(e){
			e.preventDefault();

			loginForm.querySelectorAll('.has-error').forEach(function(el){
				el.classList.remove('has-error');
			});

			loginForm.querySelectorAll('.login__error-text:not(.hidden)').forEach(function(el){
				el.classList.add('hidden');
			})

			let bError = false;
			requireElements.forEach(function(el){
				if (!el.checkValidity()) {
					var errorType = el.validity.valueMissing ? 'valueMissing' : 'valueInvalid';
					var errorEl = el.nextElementSibling;
					if (errorEl) {
						errorEl.innerHTML = el.dataset[errorType];
						errorEl.classList.remove('hidden');
					}
					el.classList.add('has-error');

					bError = true;
				}
			});

			if (bError) {
				return;
			}

			submitBtn.disabled = true;
			submitBtn.textContent = submitBtn.dataset.wait;

			fetch(loginForm.getAttribute('action'), {
				method: 'post',
				body: new URLSearchParams(new FormData(loginForm)).toString(),
				credentials: 'include',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
				},
			}).then(response => {
				return response.text();
			}).then(resp => {
				submitBtn.disabled = false;
				submitBtn.textContent = oemBtnState;

				if (resp == 100 || resp == "ok" ) {
					window.location.reload();
				} else {
					document.getElementById('login-error').classList.remove('hidden');
				}
			});
		});
	}

	// logout
	document.addEventListener('click', function(e){
		let logoutBtn = e.target.closest('.js-logout');
		if (logoutBtn && !logoutBtn.classList.contains('js-disabled')) {
			
			e.preventDefault();

			logoutBtn.classList.add('js-disabled');

			// fetch('/data/logout.json', {
			fetch('/logout/', {
				method: 'post',
				credentials: 'include',
			}).then(response => {
				return response.text();
			}).then(json => {
				window.location.reload();
			});
		}
	});
	/*========================================================*/


	/*
	* Picking region
	*/
	var regionsAll,
			request = new XMLHttpRequest(),
			regionsPopup = document.querySelector('.popup--regions'),
			regionsList = document.querySelector('.region-list'),
			regionSearchLine = document.querySelector('input[name="region-search"]');
	if (regionSearchLine) {
		function drawRegions(regions) {
			
			regionsList.innerHTML = '';

			regions.forEach(function(region){
				
				var li = document.createElement('div');
				li.classList.add('region-list__item');

				if (region.hasOwnProperty('name')) {
					var area = document.createElement('div');
					area.classList.add('region-list__area');

					var areaLink = document.createElement('a');
					areaLink.classList.add('link', 'link--grey');
					areaLink.href = region.url;
					areaLink.textContent = region.name;
					areaLink.setAttribute('data-action', region.action);
					areaLink.setAttribute('data-region', region.id);
					area.appendChild(areaLink);

					li.appendChild(area);
				}			

				var citiesList = document.createElement('ul');
				citiesList.classList.add('region-list__cities');			
				
				region.items.forEach(function(subreg){
					
					var citiesLi = document.createElement('li');
					citiesLi.classList.add('region-list__city');

					var cityLink = document.createElement('a');
					cityLink.classList.add('link', 'link--grey');
					cityLink.href = subreg.url;
					cityLink.textContent = subreg.name;
					cityLink.setAttribute('data-action', subreg.action);
					cityLink.setAttribute('data-region', subreg.id);
					citiesLi.appendChild(cityLink);

					citiesList.appendChild(citiesLi);
				})
				
				if (citiesList.hasChildNodes()){
					li.appendChild(citiesList);
				}

				if (li.hasChildNodes()){
					regionsList.appendChild(li);
				}
			});
		}

		regionSearchLine.addEventListener('input', function(){
			var val = this.value.trim(),
					filteredRegions = [];

			regionsAll.forEach(function(region){
				var filteredRegion = {};

				if (region.name.toLowerCase().indexOf(val.toLowerCase()) != -1) {
					filteredRegion.name = region.name;
					filteredRegion.url = region.url;
				}

				filteredRegion.items = [];
				region.items.forEach(function(city){
					if (city.name.toLowerCase().indexOf(val.toLowerCase()) != -1) {
						filteredRegion.items.push(city);
					}
				})

				filteredRegions.push(filteredRegion);
			});

			drawRegions(filteredRegions);
		});	

		// request.open('get', '/data/get-cities.json', true);
		request.open('get', 'https://www.restate.ru/siteforms/getcities/', true);
		request.onreadystatechange = function () {
			if (this.readyState != 4) return;

			var resp = JSON.parse(this.response);
			regionsAll = resp.regions;
			drawRegions(regionsAll);
		};

		request.onerror = function () {
			console.log('get cities: connection error');
			submitBtn.disabled = false;
		};

		regionsPopup.addEventListener('click', function(e) {
			const regionLink = e.target.closest('.link');

			if (regionLink) {
				
				const searchForm = document.querySelector('.search-list__form .slp-form__container');

				if (searchForm) {
					e.preventDefault();

					const regionInput = searchForm.querySelector('[data-region-picker]'),
								inputSearchPicked = searchForm.querySelector('.input-search__picked');

					searchForm.setAttribute('action', regionLink.dataset.action);
					regionInput.value = regionLink.dataset.region;

					inputSearchPicked.value = '';

					searchForm.submit();
				}
			}
		});

		request.send();
	}
	/*========================================================*/


	// video preview
	document.addEventListener('click', function(e) {
		const previewBtn = e.target.closest('.video-preview__btn');

		if (!previewBtn) {
			return;
		}

		const wrp = previewBtn.parentNode,
			videoUid = wrp.dataset.uid,
			video = document.createElement('iframe');

		video.src = `https://www.youtube.com/embed/${videoUid}?autoplay=1`;
		video.setAttribute('frameborder', 0);
		video.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
		video.classList.add('video-preview__video');

		wrp.classList.remove('video-preview--init');
		wrp.textContent = '';
		wrp.appendChild(video);
	});

	/*
	* hidden items
	*/
	document.addEventListener('click', function(e){
		const target = e.target.closest('.js-show-hidden');
		if (target) {
			const wrp = target.closest('.js-hidden-wrp'),
						hiddenItems = wrp.querySelectorAll('.js-hidden-item');

			hiddenItems.forEach(function(el){
				el.classList.remove('js-hidden-item');
			});
			target.remove();
		}
	});


	// Show advert info popups
	document.addEventListener('click', (e) => {
		const advertBtn = e.target.closest('.da-info__icon')
		
		if (advertBtn) {
			const wrp = advertBtn.closest('.da-info');
			wrp.classList.toggle('da-info--active');
		}
	})

	// copyLink
	document.addEventListener('click', function(e){
		const copyLink = e.target.closest('[data-copy-href-btn]');

		if (!copyLink) {
			return;
		}

		navigator.clipboard.writeText(copyLink.dataset.url)
			.then(function() {
				const oemText = copyLink.textContent;
				copyLink.textContent = copyLink.dataset.successText;
				
				setTimeout(function(){
					copyLink.textContent = oemText;
				}, 3000);
			}, function(err) {
				console.error('Async: Could not copy text: ', err);
			});
	});


	// 
	// This file includes in every layouts.
	// The code before this check should work in every layouts
	// And code after should work only at last layout.
	// In every old layouts footer has class footer, but last layout has footer width class f
	// 
	if (!document.querySelector('.f')) {
		return;
	}


	/*
	* Checklist switching
	*/
	document.addEventListener('click', function(e){
		let item = e.target.closest('.checklist__item');

		if (!item) {
			return;
		}

		const checkList = item.closest('.checklist'),
					isMulti = checkList.classList.contains('checklist--multi'),
					isActive = item.classList.contains('checklist__item--active'),
					input = checkList.querySelector('.checklist__input');		

		if (input) {
			e.preventDefault();
			
			if (!isMulti) {
				let activeOld = checkList.querySelector('.checklist__item--active');
				if (activeOld) {
					activeOld.classList.remove('checklist__item--active');
				}
				input.pickedVars = [];
			}

			if (!input.pickedVars) {
				switchInputInitialize(input);
			}
			
			if (isActive) {
				item.classList.remove('checklist__item--active');
				let value = item.dataset.value,
						index = input.pickedVars.indexOf(value);

				if (index > -1) {
					input.pickedVars.splice(index, 1);
				}
			} else {
				item.classList.add('checklist__item--active');
				input.pickedVars.push(item.dataset.value);
			}

			input.value = input.pickedVars.join('|');

			let event = new Event('change', {bubbles: true});
			input.dispatchEvent(event);
		}		
	});

	// initialize
	function switchInputInitialize(input) {
		if (input.value) {
			input.pickedVars = input.value.split('|');

			const list = input.parentNode;
			input.pickedVars.forEach(val=>{
				list.querySelector('.checklist__item[data-value="' + val + '"]').classList.add('checklist__item--active');
			});
		} else {
			input.pickedVars = [];
		}
	}
	checkListInputs.forEach(input => {
		switchInputInitialize(input);		
	});


	/*
	* Inputmask tel init
	*/
	const telephoneInputs = document.querySelectorAll('[data-input-tel]');
	telephoneInputs.forEach(function(telephoneInput){
		IMask(telephoneInput, {
			mask: '+{7}(000)000-00-00'
		});
		telephoneInput.removeAttribute('data-not-inited');
	});

	/*
	* init accordions
	*/ 
	document.addEventListener('click', function(e) {
		const acc = e.target.closest('.acc__header');
		if (!acc) {
			return;
		}
		
		acc.classList.toggle('active');
		var panel = acc.nextElementSibling;
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + 'px';
		}
	});

	const accXs = document.querySelectorAll('.acc-xs__button');
	accXs.forEach(function(btn){
		btn.addEventListener('click', function () {
			var parent = btn.closest('.acc-xs'),
					panel = btn.nextElementSibling;
			
			parent.classList.toggle('acc-xs--opened');

			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	});

	/*
	* Popups
	*/
	// Close popup when click on close btn, or click outside popup
	const closePopup = popup => {

		if (popup.hasAttribute('data-delete')) {
			popup.remove();
		} else {
			popup.classList.remove('popup--active');
			
			const popupError = popup.querySelector('.popup__error');
			if (popupError?.classList.contains('popup__error--active')) {
				popupError.classList.remove('popup__error--active');
			}
		}

		document.body.style.overflow = '';
	}

	document.addEventListener('click', function(e){
		var tg = e.target;

		if (tg.classList.contains('popup')) {
			closePopup(tg);
			return;
		}

		if (tg.classList.contains('popup__close-btn') || tg.hasAttribute('data-close-popup')) {
			var popup = tg.closest('.popup');
			
			closePopup(popup);
		}
	});
	
	document.addEventListener('keyup', function(e){
		if (e.keyCode == 27) {
			const popup = document.querySelector('.popup--active');
			if (popup) {
				closePopup(popup);
			}
		}		
	});

	// open popups
	document.addEventListener('click', function(e){
		const target = e.target.closest('[data-popup-target]');
		
		if (target) {
			
			// added checking A, cause not stop graphLink listener at mortage-program
			if (target.nodeName == 'A') {
				e.preventDefault();
				e.stopPropagation();
			}


			const popup = document.querySelector('.'+target.dataset.popupTarget);
			if (target.dataset.popupTarget == 'popup--subscribe') {
				popup.classList.remove('popup--subscribe-bottom');
			}
			
			// reset popup data
			const hiddenElements = popup.querySelectorAll('.js-hide-on-result');
			if (hiddenElements.length) {
				hiddenElements.forEach(function(el){
					el.style.display = '';
				});
			}
			const showedResult = popup.querySelector('.js-show-on-result');
			if (showedResult) {
				showedResult.innerHTML = '';
			}

			const form = popup.querySelector('form');
			if (form) {
				form.reset();
			}

			// insert data
			if (target.hasAttribute('data-input-values')) {
				let data = JSON.parse(target.dataset.inputValues);
				for (let key in data) {
					popup.querySelector('[name="'+key+'"]').value = data[key];
				}
			}

			mobileMenu.classList.remove('mm--opened');
			popup.classList.add('popup--active');
			document.body.style.overflow = 'hidden';
			
			if ( (typeof grecaptcha !== 'undefined') && popup.querySelector('.js-recaptcha')) {
				grecaptcha.reset();
			}

			return false;
		}
	});
	/*========================================================*/


	// subscribe popup
	const subscribeForm = document.querySelector('.subscr__wrp'),
				subscribePopup = document.querySelector('.popup--subscribe');
	if (subscribeForm && subscribePopup) {

		function showSubscr() {
			if (!subscribePopup.classList.contains('popup--active')) {
				subscribePopup.classList.add('popup--active', 'popup--subscribe-bottom')
			}
		}
		
		if ( !subscribePopup.hasAttribute('data-not-auto-show') ||
			( subscribePopup.hasAttribute('data-not-auto-show') && (window.innerWidth >= 1020) )
		 ) {
			setTimeout(showSubscr, 20000);
		}

		const errorEl = subscribeForm.querySelector('.subscr__error'),
					telInput = subscribeForm.querySelector('[data-input-tel]');
		subscribeForm.addEventListener('submit', function(e){
			e.preventDefault();

			let input = document.querySelector('.subscr__input[required]'),
					query = '';
			errorEl.classList.add('hidden');

			if (!input.checkValidity()) {
				if (errorEl) {
					errorEl.textContent = input.dataset.invalidValue;
					errorEl.classList.remove('hidden');
				}
				return;
			}

			if (telInput && telInput.value) {
				let telPhone = telInput.value.replace(/\D/gi, '').substring(1);
				
				if ( (telInput.value.length < 16) || (/^(.)\1+$/.test(telPhone) ) ) {
					errorEl.textContent = telInput.dataset.invalidValue;
					errorEl.classList.remove('hidden');

					return;
				}
			}

			query = new URLSearchParams(new FormData(subscribeForm)).toString();
			query += "&id="+subscribeForm.dataset.id;

			fetch('/fastreg/', {
				method: 'post',
				body: query,
				credentials: 'include',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
				}
			}).then(response => {
				return response.json();
			}).then(json => {

				if (json.err) {
					errorEl.textContent = json.msg;
					errorEl.classList.remove('hidden');
					return;
				}

				if (!json.registered) {
					
					subscribeForm.style.display = 'none';
					
					const descr = document.querySelector('.subscr__descr');
					descr.textContent = json.msg;
					descr.style.display = 'block';

				} else {
					let email = subscribeForm.querySelector('.subscr__input[type="email"]');
					email.style.display = 'none';
					email.required = false;

					let tel = subscribeForm.querySelector('.subscr__input[data-input-tel]');
					tel.style.display = 'none';

					let passwd = subscribeForm.querySelector('.subscr__input[type="password"]');
					passwd.style.display = '';
					passwd.required = true;

					let userId = subscribeForm.querySelector('.subscr__input--user-id');
					userId.value = json.id;

					let descr = document.querySelector('.subscr__descr');
					descr.textContent = json.msg;
					descr.style.display = 'block';
				}
			});
		});
	}

	/*========================================================*/


	/*
	* format numbers
	*/ 
	document.addEventListener('focusin', function(e){
		const target = e.target;
		
		if (target.hasAttribute('data-only-num')) {
			target.value = target.value.replace(/\s/g, '');
		}
	});

	document.addEventListener('input', function(e){
		const target = e.target;

		// let keys = ['0','1','2','3','4','5','6','7','8','9','.',','];
		// console.log(keys.indexOf(e.key) > -1);
		// return keys.indexOf(e.key) > -1;
		if (target.hasAttribute('data-only-num')) {
			target.value = regular(target.value);
		}
	});

	document.addEventListener('focusout', function(e){
		const target = e.target;
		
		if (target.hasAttribute('data-only-num') && target.value) {

			let min = target.getAttribute('min'),
					max = target.getAttribute('max'),
					value = target.value;

			if (max && (value > max) ) {
				value = max;
			}

			if (min && (value < min) ) {
				value = min;
			}

			target.value = new Intl.NumberFormat('ru').format(value);
		}
	});


	/*
	* change input value by range
	*/ 
	document.addEventListener('change', function(e){
		const range = e.target;
		if (range.classList.contains('input-line__range')) {
			
			if (range.closest('.bmage')) {
				// kostyl' for old layout
				return;
			}

			e.preventDefault();

			const targetInput = range.previousElementSibling;

			if (targetInput.hasAttribute('data-only-num')) {
				targetInput.value = new Intl.NumberFormat('ru').format(range.value);
			} else {
				// targetInput.value = range.value;
			}

			let event = new Event('change', {bubbles: true});
			targetInput.dispatchEvent(event);
		}
	});


	/*
	* main
	*/
	const mainFormOpenBtn = document.querySelector('.main-search__open-form-btn');
	if (mainFormOpenBtn) {
		const mainFormWrp = document.querySelector('.main-search__form-wrp'),
					mainFormCloseBtn = document.querySelector('.main-search__form-close-btn');

		mainFormOpenBtn.addEventListener('click', function() {
			mainFormWrp.classList.add('main-search__form-wrp--opened');
			document.body.style.overflow = 'hidden';
		});

		mainFormCloseBtn.addEventListener('click', function() {
			mainFormWrp.classList.remove('main-search__form-wrp--opened');
			document.body.style.overflow = '';
		});

		/*
		* Form has input and select for price value.
		* Input should submit on PC, and select on mobile.
		* so we remove or set propert name, to send only one value
		*/
		// function setPriceInputName() {
		// 	if (window.innerWidth < 768) {
		// 		priceValueXl.removeAttribute('name');
		// 		priceValueXs.setAttribute('name', priceFieldName);
		// 	} else {
		// 		priceValueXl.setAttribute('name', priceFieldName);
		// 		priceValueXs.removeAttribute('name');
		// 	}
		// }

		// window.addEventListener('resize', setPriceInputName);
		// setPriceInputName();

		const dealidValue = document.querySelector('.main-search__dealid-input').value;
		const searchForm = {
			data() {
				return {
					dealid: dealidValue,
					regionId: '',
					type: 'flat',
					priceType: 1,
					mobile: window.innerWidth < 768
				}
			},
			mounted() {

				this.initPriceInput();
				this.initRegions();

				this.type = this.$refs.typeEl.options[this.$refs.typeEl.selectedIndex].dataset.type;

				window.addEventListener('resize', () => {
					this.mobile = window.innerWidth < 768
					this.initPriceInput();
				});
			},
			watch: {
				'type': function(newType, oldType) {
					if ( (newType == 'land') || (oldType == 'land') ) {
						this.priceType = 1;
					}
					this.updatePriceType();
				},
				'dealid': function() {
					this.priceType = 1;
					this.updatePriceType();
				},
				'priceType': function() {
					this.initPriceInput();
				},
			},
			methods: {
				initPriceInput() {
					this.$nextTick(function () {
						if (this.$refs.priceText) {
							IMask(this.$refs.priceText, {
								mask: Number,
								signed: false,
								thousandsSeparator: ' ',
							});
						}
					});
				},
				initRegions() {
					fetch('https://www.restate.ru/siteforms/getcities/', {
						method: 'get'
					}).then(response => {
						return response.json();
					}).then(res => {
						this.drawRegions(res.regions)
					}).catch(function(error) {
						console.error(error);
					});
				},
				drawRegions(regions) {

					const picker = this.$refs.regionEl,
						select = picker.querySelector('select');

					regions.forEach(function(region){

						const opt = document.createElement('option');
						opt.value = region.id;
						opt.textContent = region.name;
						opt.setAttribute('data-action', region.action);
						opt.setAttribute('data-header-link', '');
						select.appendChild(opt);
						
						region.items.forEach(function(subreg){

							const opt = document.createElement('option');
							opt.value = subreg.id;
							opt.textContent = subreg.name;
							opt.setAttribute('data-action', subreg.action);
							select.appendChild(opt);
						})
					});

					select.value = this.$refs.mainForm.dataset.regionDef;
					select.dispatchEvent(new Event('change'));
					pickerObj.rebuildPicker(this.$refs.regionEl);
				},
				changeDealId(target) {
					this.dealid = target.dataset.value;
				},
				changeType() {
					this.type = this.$refs.typeEl.options[this.$refs.typeEl.selectedIndex].dataset.type;
				},
				changeRegion(e) {
					const select = e.target;

					this.regionId = select.value;

					this.$refs.mainForm.setAttribute('action', select.options[select.selectedIndex].dataset.action)

					// Расширенный поиск есть только для Спб, Мск, ЛО или МО то
					if (['1','2','3','4'].indexOf(this.regionId) != -1 ) {
						this.$refs.moreLink.style.display = '';
					} else {
						this.$refs.moreLink.style.display = 'none';
					}
				},
				updatePriceType() {
					this.$nextTick(function () {
						pickerObj.rebuildPicker(this.$refs.priceType);
						this.initPriceInput();
					});
				},
				updateLinks() {
					const query = new URLSearchParams(new FormData(this.$refs.mainForm)).toString();

					const moreLink = this.$refs.moreLink;
					moreLink.href = moreLink.href.substr(0, moreLink.href.indexOf('?')) + '?frompodbor2021=1&' + query;

					this.$nextTick(function () {
						const url = new URL(this.$refs.mainForm.action);
						const mapLink = this.$refs.mapLink;

						let host;
						if ( (this.regionId == '1') ||  (this.regionId == '3') ) {
							// Спб и ЛО
							host = '//spb.restate.ru';
						} else {
							if ( (this.regionId == '2') ||  (this.regionId == '4') ) {
								// Мск и МО
								host = '//msk.restate.ru';
							} else {
								// Все остальные регионы
								host = url.hostname;
							}
						}
						mapLink.href = '//' + host + '/map/?' + query;
					});
				},
				processSubmit: function(e) {
					e.preventDefault();
					
					if (this.$refs.priceText) {
						this.$refs.priceText.value = this.$refs.priceText.value.replace(/\s/g, '')
					}

					const btn = this.$refs.submitBtn;
					btn.textContent = 'Минуту...';
					btn.disabled = true;

					e.target.submit();
				}
			}
		}

		Vue.createApp(searchForm).mount(document.querySelector('.main-search__form-container'));
	}


	/*
	* Favourite block
	*/
	const isFavourite = document.querySelector('.js-favourite');

	/*
	* Adding to favourite list
	* Target: items list, base, favourites
	*
	* Idea:
	* If btn is on items list or base page, then it should have href.
	* If btn is inactive in first click it become active, 
	* and at the second click location will change to fav page.
	*
	* If btn is on fav page, then it should have no href attribute.
	* Click just will change it's state.
	*/
	function refreshFavCounter(e, favBtn) {
		e.stopPropagation();
		e.preventDefault();

		var request = new XMLHttpRequest();
		// request.open('get', './data/test.json', true);
		request.open('post', '/addBookmark/', true);
		request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8');

		request.onreadystatechange = function () {
			if (this.readyState != 4) return;
			
			favBtn.classList.toggle('active');

			let label = favBtn.querySelector('[data-success]');
			
			if (label) {

				// если находимся на странице Избранное
				if(!favBtn.classList.contains('active')){
					if(label.classList.contains('js-fav-cli')) {
						[favBtn.title] = [label.dataset.error];
					} else {
						[favBtn.querySelector('.icon-btn__name').textContent] = [label.dataset.error];
					}
				} else {
					if(label.classList.contains('js-fav-cli')) {
						[favBtn.title] = [label.dataset.success];
					} else {
						[favBtn.querySelector('.icon-btn__name').textContent] = [label.dataset.success];
					}
				}

			}

			const favCountEl = document.querySelector('.rl__icon-wrp--fav .rl__icon'),
						counterEl = document.querySelector('.rl__icon-wrp--fav .rl__counter');
			let count;
			if (favBtn.classList.contains('active')) {
				count = parseInt(favCountEl.dataset.count) + 1;
			} else {
				count = parseInt(favCountEl.dataset.count) - 1;
			}

			if (count) {
				favCountEl.classList.add('rl__icon--active');
			} else {
				favCountEl.classList.remove('rl__icon--active');
			}

			favCountEl.dataset.count = count;
			counterEl.textContent = count;

			favBtn.classList.remove('disabled-link');
		};

		request.onerror = function () {
			console.log('Add to favourite connection error');
			favBtn.classList.remove('disabled-link');
		};

		favBtn.classList.add('disabled-link');
		let data = "title_val=" + favBtn.dataset.title + "&href_val=" + favBtn.dataset.href;
		request.send(data);
	};

	document.addEventListener('click', function (e) {

		var favBtn = e.target.closest('[data-add-to-fav]');
		if (!favBtn) {
			return;
		}

		if (favBtn.classList.contains('disabled-link')) {
			e.stopPropagation();
			e.preventDefault();
			return false;
		}

		// если находимся на странице Избранное
		if(isFavourite && favBtn.classList.contains('active')) {
			refreshFavCounter(e, favBtn);
		}

		if (!favBtn.hasAttribute('href') || !favBtn.classList.contains('active')) {
			refreshFavCounter(e, favBtn);
		}
	});


	/*
	* Adding to compare list
	* Target: items list, base, compare page
	*
	* Idea:
	* If btn is on items list or base page, then it should have href.
	* If btn is inactive in first click it become active, 
	* and at the second click location will change to compare page.
	*
	* If btn is on compare page, then it should have no href attribute.
	* Click just will change it's state.
	*/
	var compareBtn;

	function processCompare(link) {
		let request = new XMLHttpRequest();

		// request.open('post', '/data/compare.json', true);
		request.open('post', link, true);
		request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8');

		request.onreadystatechange = function () {
			if (this.readyState != 4) return;

			let resp = JSON.parse(this.response);

			if (resp.result === 'rewrite'){
				// user want to add another type item
				document.body.style.overflow = 'hidden';
				let popup = document.querySelector('.popup--compare-change-type');
				popup.querySelector('[data-continue-compare]').itemInfo = {}
				popup.classList.add('popup--active');
			} else {
				compareBtn.classList.toggle('active');

				let label = compareBtn.querySelector('[data-success]');
				if (label) {
					[compareBtn.querySelector('.icon-btn__name').textContent] = [label.dataset.success];
				}

				if ( resp.result.indexOf(',') !== -1 ){
					g.compares = resp.result.split(',');

					if (compareBtn.classList.contains('active')) {
						document.body.style.overflow = 'hidden';
						document.querySelector('.popup--compare-add').classList.add('popup--active');
					}
				}
			}

			compareBtn.classList.remove('disabled-link');
		}

		request.onerror = function () {
			console.log('Add to compare connection error');
			compareBtn.classList.remove('disabled-link');
		};

		compareBtn.classList.add('disabled-link');
		request.send();
	}

	function initCompare() {
		let compares = getCookie('_compare_data_1');
		if (compares) {
			g.compares = compares.split(',');
		}
	}

	document.addEventListener('click', function (e) {
		let maybeComapreBtn = e.target.closest('[data-add-to-compare]');
		if (!maybeComapreBtn) {
			return;
		}

		compareBtn = maybeComapreBtn;		

		if (compareBtn.classList.contains('disabled-link')) {
			e.stopPropagation();
			e.preventDefault();
			return false;
		}

		if (!compareBtn.hasAttribute('href') || !compareBtn.classList.contains('active')) {
			e.stopPropagation();
			e.preventDefault();
		}

		let link,
				id = compareBtn.dataset.id,
				type = compareBtn.dataset.type,
				fromRegion = compareBtn.dataset.freg;

		if (compareBtn.classList.contains('active')) {
			link = '/compare/del/' + fromRegion + '/' + type + '/'+ id;
		} else {
			link = '/compare/add/' + fromRegion + '/' + type + '/'+ id +'/?type=0&protected=1';
		}

		processCompare(link);
	});

	let continueCompare = document.querySelector('[data-continue-compare]');
	if (continueCompare) {
		continueCompare.addEventListener('click', function(){
			let id = compareBtn.dataset.id,
					type = compareBtn.dataset.type,
					fromRegion = compareBtn.dataset.freg,
					link = '/compare/add/' + fromRegion + '/' + type + '/'+ id +'/?type=0&protected=1';
			console.log(link);
					processCompare(link);
			continueCompare.closest('.popup').classList.remove('popup--active');
			document.body.style.overflow = '';
		});
	}

	initCompare();


	/*
	* Cookie warning 
	*/
	const btn = document.querySelector('.cow__close');
	if (btn) {
		const	win = document.querySelector('.cow'),
					isShowed = getCookie('cookieShowed');

		if (!isShowed){
			win.style.display = 'block';

			btn.addEventListener('click', function(){
				win.style.display = 'none';
				setCookie('cookieShowed', 1, {expires: 60 * 60 * 24 * 14});
			});
		} else {
			// show app advert
			const app = document.querySelector('.mobile-app_t2017_2, #ios_app, #android_app');
			if (app) {
				app.classList.add('allowed');
			}
		}
	}


	/*
	* Realtors slider
	*/
	const realtorSlider = document.querySelector('.realtors-slider');
	if (realtorSlider) {
		new Swiper(realtorSlider.querySelector('.swiper-container'), {
			speed: 400,
			freeMode: true,
			slidesPerView: 'auto',
			spaceBetween: 30,
			navigation: {
				nextEl: realtorSlider.querySelector('.realtors-slider__button--next'),
				prevEl: realtorSlider.querySelector('.realtors-slider__button--prev'),
				disabledClass: 'realtors-slider__button--disabled'
			}
		});
	}
	

	/*
	* houses preview slider
	*/
	const housesPreviewSliders = document.querySelectorAll('.houses-preview__slider');
	housesPreviewSliders.forEach(slider => {
	
		const loopNeed = slider.querySelectorAll('.swiper-slide').length > 4;
		
		new Swiper(slider.querySelector('.swiper-container'), {
			spaceBetween: 20,
			loop: loopNeed,
			// freeMode: true,
			// slidesPerView: 'auto',
			navigation: {
				nextEl: slider.querySelector('.houses-preview__btn--next'),
				prevEl: slider.querySelector('.houses-preview__btn--prev'),
				disabledClass: 'houses-preview__btn--disabled'
			},
			pagination: {
				el : slider.querySelector('.houses-preview__pagination'),
				clickable: true
			},
			breakpoints: {
				500: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				992: {
					slidesPerView: 4
				},
				1024: {
					slidesPerView: 5
				}
			}
		});

	});


	/*
	* table sorting
	*/
	const sortBtns = document.querySelectorAll('.mage-offer button[data-dir]');

	function sortTable(btn) {
		let switching, shouldSwitch, switchcount = 0, rows, tdIndex, dir, i, x, y;
		tdIndex = Array.prototype.indexOf.call(btn.closest('tr').querySelectorAll('th'), btn.closest('th'));
		dir = btn.dataset.dir;
		switching = true;
	
		while (switching) {
			switching = false;
			rows = btn.closest('table').querySelectorAll('tbody tr');
	
			for (i = 0; i < (rows.length - 1); i++) {
				shouldSwitch = false;
	
				x = rows[i].getElementsByTagName('td')[tdIndex];
				y = rows[i + 1].getElementsByTagName('td')[tdIndex];
	
				if (dir == "asc") {
					if (Number(x.dataset.value) > Number(y.dataset.value) ) {
						shouldSwitch = true;
						break;
					}
				} else if (dir == "desc") {
					if (Number(x.dataset.value) < Number(y.dataset.value) ) {
						shouldSwitch = true;
						break;
					}
				}
			}
	
			if (shouldSwitch) {
				rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
				switching = true;
				switchcount ++;
			} else {
				if (switchcount == 0 && dir == "asc") {
					dir = "desc";
					switching = true;
				}
			}
		}
	}

	sortBtns.forEach(function(btn){
		btn.addEventListener('click', function(){
			sortTable(this);

			const oldActive = document.querySelector('.mage-offer button.active');
			if (oldActive){
				oldActive.classList.remove('active');
			}
			this.classList.add('active');
		});
	});


	const complexTelBtns = document.querySelectorAll('.cli__call-btn--show-now');
	complexTelBtns.forEach(function(btn){
		btn.addEventListener('click', function(){
			btn.textContent = btn.dataset.tel;
			btn.setAttribute('href', 'tel:'+btn.dataset.tel);

			if (window.innerWidth < 768){
				window.location = 'tel:'+btn.dataset.tel;
			}
		});
	});


	const anchorLinks = document.querySelectorAll('[data-anchor-link]');
	anchorLinks.forEach(function(link){
		link.addEventListener('click', function(e){
			e.preventDefault();

			const target = link.getAttribute('href').substring(1),
						targetEl = document.getElementById(target);
			let offset = targetEl.getBoundingClientRect().top + window.scrollY,
				headerHieght = document.querySelector('header').scrollHeight;
			
			offset -= headerHieght;
			
			window.scrollTo({top: offset, behavior: 'smooth'});
			sendHint(`${window.location}#${target}`);
		});
	});


	/* Load locallists on main */
	const loadMoreCitiesBtns = document.querySelectorAll('.mlinks__show-more');
	loadMoreCitiesBtns.forEach(loadMoreCitiesBtn => {
		loadMoreCitiesBtn.addEventListener('click', function() {
			
			loadMoreCitiesBtn.textContent = loadMoreCitiesBtn.dataset.wait;
			loadMoreCitiesBtn.disabled = true;
			
			fetch('/localist/', {
				method: 'post',
				body: 'type=' + loadMoreCitiesBtn.dataset.type + '&id=' + loadMoreCitiesBtn.dataset.id,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
				},
			}).then(response => {
				return response.text();
			}).then(resHtml => {
				
				const wrp = loadMoreCitiesBtn.closest('.mlinks').querySelector('.mlinks__list');
				wrp.innerHTML = resHtml;
				loadMoreCitiesBtn.remove();

			}).catch(function(error) {
				console.error(error);
			});
		});
	})


	/*
	* INPUT FILES
	*/

	/* Photo previews
	*
	* Min width height sould be MIN_WIDTH_HEIGHT.
	* But if you don't want to check size, then put 'data-donot-check-size' attribute on photo input
	*
	*/
	var MIN_WIDTH_HEIGHT = 600,
			photoInputs = document.querySelectorAll('.input-line__photo-input'),
			fileDelBtns = document.querySelectorAll('.input-line__photo-del-btn');

	function deleteFile(el){
		var wrp = el.closest('.input-line__photo');
		wrp.style.backgroundImage = '';
		wrp.classList.remove('input-line__photo--loaded');

		wrp.querySelector('input').value = null;
	}
	
	function makeThumbnail(el){

		var error = document.querySelector('.input-line__photo--error');
		if (error){
			error.classList.remove('input-line__photo--error');
		}

		var input = el,
				preview = input.closest('label'),
				reader = new FileReader();

		reader.onload = function (e) {
			var img = new Image();

			img.onload = function (e) {

				if (!el.hasAttribute('data-donot-check-size')){

					// if hasn't then check min size
					if ( (this.width >= MIN_WIDTH_HEIGHT) || (this.height >= MIN_WIDTH_HEIGHT) ){
						preview.style.backgroundImage = 'url(' + reader.result + ')';
						preview.classList.add('input-line__photo--loaded');
					} else {
						preview.classList.add('input-line__photo--error')
						deleteFile(input);
					}
				} else {
					preview.style.backgroundImage = 'url(' + reader.result + ')';
					preview.classList.add('input-line__photo--loaded');
				}
			}

			img.src = reader.result;
		};

		reader.readAsDataURL(el.files[0]);
	}

	// Create preview
	document.addEventListener('change', function(e){
		let photoInput = e.target.closest('.input-line__photo-input');

		if (photoInput) {
			makeThumbnail(photoInput);
		}

		
	});

	// Delete photos by del btn
	document.addEventListener('click', function(e){
		let fileDelBtn = e.target.closest('.input-line__photo-del-btn');
		
		if (fileDelBtn) {
			deleteFile(fileDelBtn);
		}
	});


	// delete subscribes
	const delSubscribeBtns = document.querySelectorAll('.subscribe-list__delete-btn');
	if (delSubscribeBtns.length) {
		const popup = document.querySelector('.popup--compare-delete-subscribe'),
					processBtn = document.querySelector('[data-continue-delete-subscribe]'),
					processBtnState = processBtn.textContent,
					popupError = popup.querySelector('.popup__error');

		delSubscribeBtns.forEach(btn => {
			btn.addEventListener('click', function(){
				processBtn.clickedBtn = btn;
			});
		})

		processBtn.addEventListener('click', function(){
			processBtn.disabled = true;
			processBtn.textContent = WAITING_TEXT;

			const url = !processBtn.clickedBtn.dataset.type ? 
				'/newsletter/delete/' + processBtn.clickedBtn.dataset.id : 
				'/newsletter/price/del/'  + processBtn.clickedBtn.dataset.id + "/" + processBtn.clickedBtn.dataset.type;

			// fetch('/data/delSubscribe.json', {
			fetch(url, {
				method: 'post',
				// body: 'id=' + processBtn.clickedBtn.dataset.id,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
				}
			}).then(response => {
				return response.json();
			}).then(data => {
				if(data.err) {
					popupError.innerHTML = data.errorHtml;
					popupError.classList.add('popup__error--active');
				} else {
					processBtn.clickedBtn.closest('.subscribe-list__item').remove();
					popup.classList.remove('popup--active');
					document.body.style.overflow = '';
				}
			}).catch(function(error) {
				console.error(error);
			}).finally(function(){
				processBtn.disabled = false;
				processBtn.textContent = processBtnState;
			});
		});
	}


	// call btn
	const callBtns = document.querySelectorAll('.js-make-href-and-call');
	callBtns.forEach(btn => {
		btn.addEventListener('click', function() {
			const tel = btn.dataset.tel;
			btn.textContent = tel;

			if (window.innerWidth < 768){
				window.location = 'tel:'+tel;
			}
		});
	});


	// show admin form for edit
	const articleEditBtns = document.querySelectorAll('[data-article-edit-btn]');
	articleEditBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			const url = btn.dataset.href,
						target = btn.dataset.popupTarget,
						placeForForm = document.querySelector(`.${target} .edit-form-wrapper`);

			fetch(url, {
				method: 'get',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
				}
			}).then(response => {
				return response.text();
			}).then(html => {
				placeForForm.innerHTML = html;
			}).catch(function(error) {
				console.error(error);
			}).finally(function(){
				
			});
		})
	})
});



/*
* Form validation
*/
function initSimpleForm(form) {

	var requireElements = form.querySelectorAll('[required], .js-validate'),
		submitBtn = form.querySelector('.js-btn-submit'),
		agreeCheck = form.querySelector('.js-form-check-rules'),
		state = submitBtn.textContent;

	function clearFormErrors() {
		var texts = form.querySelectorAll('.input-line__error-text:not(.hidden)');
		texts.forEach(function(text){
			text.classList.add('hidden');
		});

		var styles = form.querySelectorAll('.has-error');
		styles.forEach(function(style){
			style.classList.remove('has-error');
		});
	}

	function removeSingleErrorNode(){
		var isErrorNode = this.classList.contains('has-error'),
			isRating = this.classList.contains('.rating__star');

		if (isErrorNode || isRating) {
			this.classList.remove('has-error');
			var errorText = this.closest('.input-line').querySelector('.input-line__error-text');
			if (errorText) {
				errorText.classList.add('hidden');
			}
		}
	}

	function scrollToFirstError() {
		var errEl = form.querySelector('.has-error');

		if (errEl && !isScrolledIntoView(errEl)) {
			errEl.closest('.input-line').scrollIntoView({
				behavior: 'smooth'
			});
		}
	}

	function applyAjaxResult(data) {
		if (!data.err) {
			
			if (data.elementsToHideInSuccess) {
				data.elementsToHideInSuccess.forEach(function(selector){
					var el = form.querySelector(selector);
					el.style.display = 'none';
				})
			}
			
			if (data.successHtml) {
				var successTarget = form.querySelector(data.successTarget);
				successTarget.innerHTML = data.successHtml;
				successTarget.style.display = '';
			}

			if (form.classList.contains('mage-else__form')) {

				if ( (typeof dataLayer)  != 'undefined') {
					dataLayer.push({'event': 'send_order_ipoteka'})
				}
			}

			const dlInput = form.querySelector('.js-data-layer-value');
			if (dlInput && dataLayer) {
				dataLayer.push({
					'event': dlInput.value
				});
			}
		} else {

			data.elements.forEach(function(el){
				if (el.errName == "captcha") {
					const errWrp = form.querySelector('.js-form-common-error');
					errWrp.textContent = el.message;
					errWrp.classList.remove('hidden');
				} else {
					var errEl = form.querySelector('[name="'+el.errName+'"]');
					if (errEl) {
						errEl.classList.add('has-error');
						var errText = errEl.closest('.input-line').querySelector('.input-line__error-text');
						errText.textContent = el.message;
						errText.classList.remove('hidden');
					}
				}
			});

			scrollToFirstError();
		}

		submitBtn.textContent = state;
		submitBtn.disabled = false;
	}

	requireElements.forEach(function(el){
		el.addEventListener('input', removeSingleErrorNode);
		el.addEventListener('change', removeSingleErrorNode);
	});

	if (agreeCheck) {
		agreeCheck.addEventListener('change', function() {
			submitBtn.disabled = !this.checked;
		});
	}
	
	form.setAttribute('novalidate', '');
	form.addEventListener('submit', function(e){
		e.preventDefault();

		clearFormErrors();

		var bError = false;
		requireElements.forEach(function(el){
			
			if (!el.checkValidity() || (el.hasAttribute('data-input-tel') && el.value.length < 16) ) {
				var errorType = el.validity.valueMissing ? 'valueMissing' : 'valueInvalid';
				var errorEl = el.closest('.input-line').querySelector('.input-line__error-text');
				if (errorEl) {
					errorEl.innerHTML = el.dataset[errorType];
					errorEl.classList.remove('hidden');
				}
				el.classList.add('has-error');

				bError = true;
			}
		});
		
		if (bError) {
			scrollToFirstError();
			return;
		}

		let data = new FormData(form);
		submitBtn.disabled = true;
		submitBtn.textContent = submitBtn.dataset.wait;

		fetch(form.getAttribute('action'), {
			method: form.getAttribute('method'),
			body: data
		}).then(response => {
			return response.json();
		}).then(data => {
			applyAjaxResult(data);			
		}).catch(function(error) {
			console.error(error);
		});
	});
}

document.addEventListener('DOMContentLoaded', function() {
	var forms = document.querySelectorAll('form.js-simple-submit');
	if (!forms.length) {
		return;
	}

	forms.forEach(form => {
		initSimpleForm(form);
	});
});

document.addEventListener('DOMContentLoaded', function() {
	var hiddenCommentForm = document.querySelector('.comment-form--hidden');

	if (!hiddenCommentForm) {
		return;
	}

	var commentForm = document.querySelector('.comment-form');
	var btnShow = hiddenCommentForm.querySelector('.js-show-comment-form');

	btnShow.addEventListener('click', function(){
		if(commentForm.classList.contains('comment-form--hidden')) {
			commentForm.classList.remove('comment-form--hidden');
		}
	})
});


/*
* Area searching and picking
*/
document.addEventListener('DOMContentLoaded', function(){
	const searchInput = document.querySelector('.input-search__input');
	
	if (!searchInput) {
		return;
	}

	const searchPanel = document.querySelector('.slp-form'),
				resultWrp = document.querySelector('.input-search__result'),
				mainSearchForm = document.querySelector('.main-search__form'),
				gradeForm = document.querySelector('.grade-forms'),
				additionalInput = document.querySelector('.input-search__additional');
	let cityInput = document.querySelector('[data-region-picker], .slp-form__hidden-region');

	let request = new XMLHttpRequest();
	

	function createTag(label, value){
		var tag = document.createElement('div');
		tag.classList.add('tags-list__item');
		var span = document.createElement('span');
		span.innerHTML = label;
		var closeBtn = document.createElement('i');
		closeBtn.setAttribute('data-id', value);
		closeBtn.classList.add('tags-list__item-delete');
		
		tag.appendChild(span);
		tag.appendChild(closeBtn);

		return tag;
	}

	request.onreadystatechange = function() {
		if (this.readyState != 4) return;

		if (this.response){
			resultWrp.innerHTML = this.response;
			resultWrp.style.display = '';
		}
	}

	request.onerror = function() {
		console.log('.input-search__input: connection error');
	}

	// send search request
	searchInput.addEventListener('input', function(){
		var value = searchInput.value;

		// cancel old request
		if (typeof request != 'undefined' && 
				( (request.readyState == 2) || (request.readyState == 3) ) ){
			request.abort();
		}

		// Send new one
		// request.open('post', window.location.origin+'/showplaceselect/', true);
		request.open('post', window.location.origin+'/showplaceselect/', true);
		request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8');

		let data = '';
		if (cityInput) {
			data = cityInput.getAttribute('name')+'='+cityInput.value + '&';
		}
		if (additionalInput) {
			data += additionalInput.getAttribute('name')+'='+additionalInput.value + '&';
		}

		data += 'q='+value
		request.send(data);
		
	});

	// close popup
	document.addEventListener('click', function(e){
		const resDropDown = e.target.closest('.input-search__result');

		if (!resDropDown) {
			resultWrp.style.display = 'none';
		}
	});

	document.addEventListener('keyup', function(e){
		if (e.keyCode == 27) {
			resultWrp.style.display = 'none';
		}
	});

	if (cityInput) {
		// detect change because vue add regions
		const config = {
			childList: true
		};
		const callback = function(mutationsList, observer) {
			cityInput = document.querySelector('[data-region-picker], .slp-form__hidden-region');
		};
		const observer = new MutationObserver(callback);
		observer.observe(cityInput, config);
	}

	if (searchPanel) {
		const searchForm = document.querySelector('.slp-form__container'),
					tagsContainer = searchPanel.querySelector('.tags-list'),
					pickedTagsEl = searchPanel.querySelector('.input-search__picked');
		
		let pickedTagsArr = pickedTagsEl.value ? pickedTagsEl.value.split('|') : [];

		function changeRegion() {
			const action = cityInput.options[cityInput.selectedIndex].dataset.action;
			searchForm.setAttribute('action', action);

			if (!cityInput.initialRegionChange) {
				tagsContainer.textContent = '';
				pickedTagsArr = [];
				pickedTagsEl.value = '';
			} else {
				// Изначально в списке городов только Спб, ЛО, Мск и МО.
				// Остальные города подгружаются скриптом. И после подгрузки устанавливается выбранный город.
				// Вот это изменение региона нужно отфильтровать и удалять установленные уточнения
				cityInput.initialRegionChange = false;
			}
		}

		// add new tag
		searchPanel.addEventListener('click', function(e){
			var item = e.target;

			if (!item.classList.contains('input-search__item')) {
				return;
			}

			var value = item.dataset.value,
					type = item.closest('.input-search__section').dataset.type,
					id = type+':'+value,
					region = item.dataset.regionId;

			if (pickedTagsArr.indexOf(id) == -1) {
				// this is new variant

				// region check
				if (region && (cityInput.nodeName != 'INPUT') && (cityInput.value != region) ) {
					cityInput.value = region;
					pickerObj.rebuildPicker(cityInput.parentNode);
					changeRegion();
				}

				tagsContainer.appendChild(createTag(item.dataset.label, id));

				pickedTagsArr.push(id);
				pickedTagsEl.value = pickedTagsArr.join('|');
			}			
			
			searchInput.value = '';
			resultWrp.style.display = 'none';
			resultWrp.innerHTML = '';

			let event = new Event('change', {bubbles: true});
			pickedTagsEl.dispatchEvent(event);
		});		

		// remove tag
		searchPanel.addEventListener('click', function(e){
			var item = e.target;
			
			if (!item.classList.contains('tags-list__item-delete')) {
				return;
			}

			var id = item.dataset.id;

			var index = pickedTagsArr.indexOf(id);
			if (index > -1) {
				pickedTagsArr.splice(index, 1);
			}

			pickedTagsEl.value = pickedTagsArr.join('|');
			item.parentNode.remove();
		});

		cityInput.addEventListener('change', function(){
			changeRegion();
		});
	}

	if (mainSearchForm) {

		const idInput = mainSearchForm.querySelector('.input-search__picked');

		mainSearchForm.addEventListener('click', function(e){
			const item = e.target;

			if (!item.classList.contains('input-search__item')) {
				return;
			}

			const value = item.dataset.value,
						type = item.closest('.input-search__section').dataset.type,
						id = type+':'+value,
						label = item.dataset.label,
						action = item.dataset.action,
						region = item.dataset.regionId;

			idInput.value = id;
			searchInput.value = label;

			let event = new Event('change', {bubbles: true});
			idInput.dispatchEvent(event);

			resultWrp.style.display = 'none';
			resultWrp.innerHTML = '';

			if (action) {
				mainSearchForm.setAttribute('action', action);
			}

			if (region && cityInput && (cityInput.value != region) ) {
				cityInput.value = region;
				cityInput.dispatchEvent(new CustomEvent('change', {detail: "handmaid"}));
				pickerObj.rebuildPicker(cityInput.parentNode);
			}
		});

		if (cityInput) {

			cityInput.addEventListener('change', function(e) {
				if (!e.detail) {
					idInput.value = '';
					searchInput.value = '';
				}
			});
		}
	}

	if (gradeForm) {
		gradeForm.addEventListener('click', function(e){
			const item = e.target;

			if (!item.classList.contains('input-search__item')) {
				return;
			}

			searchInput.value = item.dataset.label;

			resultWrp.style.display = 'none';
			resultWrp.innerHTML = '';
		})
	}
	
});


/*
* Comments
*/
document.addEventListener('DOMContentLoaded', function() {
	
	const commentForm = document.querySelector('.comment-form');

	if (!commentForm) {
		return;
	}

	const oemFormClone = commentForm.cloneNode(true),
				replyBtns = document.querySelectorAll('.comments-list__answer-btn');

	replyBtns.forEach(btn => {

		btn.addEventListener('click', function() {
			// remove old forms
			const oldForm = document.querySelector('.comments-list__item .comment-form');
			if (oldForm) {
				oldForm.remove();
			}

			const id = btn.dataset.id,
						parent = btn.closest('.comments-list__item');

			let replyForm = oemFormClone.cloneNode(true),
					form = replyForm.querySelector('.comment-form__form'),
					replyId = document.createElement('input');

			replyId.setAttribute('type', 'hidden');
			replyId.setAttribute('name', 'reply-id');
			replyId.setAttribute('value', id);
			form.appendChild(replyId);

			initSimpleForm(form);
			parent.appendChild(replyForm);
			if ( (typeof grecaptcha !== 'undefined') && parent.querySelector('.js-recaptcha')) {
				grecaptcha.render(parent.querySelector('.js-recaptcha'), {});
			}
		});
	});
});


document.addEventListener('DOMContentLoaded', function() {
	/*
	* Promo slider
	*/
	const promoSlider = document.querySelector('.promo__slider');
	if (promoSlider) {
		new Swiper(promoSlider.querySelector('.swiper-container'), {
			pagination: {
				el : promoSlider.querySelector('.promo__slider-pagination'),
				clickable: true
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
				},
				480: {
					slidesPerView: 2,
					spaceBetween: 30,
					loop: true,
				},
				640: {
					slidesPerView: 3,
					spaceBetween: 30,
					loop: true,
				},
				// when window width is >= 1280px
				1280: {
					slidesPerView: 4,
					spaceBetween: 50,
					loop: false
				}
			},
		});
	};
});


// раскрытие пунктов в блоке очередей
document.addEventListener('DOMContentLoaded', function () {

	var btns = document.querySelectorAll('.queue__more'),
			state = '';

	if (!btns) {
			return;
	}

	btns.forEach(function(btn) {
		btn.addEventListener('click', function () {
			const hidden = btn.closest('.queue').querySelector('.queue__hidden');

			if (state == '') {
				state = btn.innerHTML;
			}

			if (hidden.style.maxHeight) {
				hidden.style.maxHeight = null;
				btn.innerHTML = state;
			} else {
				hidden.style.maxHeight = hidden.scrollHeight + "px";
				btn.innerHTML = btn.dataset.close;
			}
		});
	})

});

// открытие popup акций
// вынесла из complex.js тк используется на complex и opinions
document.addEventListener('DOMContentLoaded', function () {
	// actions popup
	const pActionsLinks = document.querySelectorAll('.cactions__action-link'),
				actionsPopup = document.querySelector('.pactions');
	pActionsLinks.forEach(link => {
		link.addEventListener('click', function() {
			const header = link.querySelector('.js-popup-action-title');
			if (header) {
				actionsPopup.querySelector('.pactions__header').textContent = header.textContent;
			}
			actionsPopup.querySelector('.pactions__text').textContent = link.querySelector('.js-popup-action-descr').textContent;
			actionsPopup.querySelector('.pactions__comple-header').textContent = link.querySelector('.js-popup-action-content-title').textContent;
			actionsPopup.querySelector('.pactions__complex-descr').textContent = link.querySelector('.js-popup-action-content-descr').textContent;
		})
	});

	// actions slider
	const cactionSlider = document.querySelector('.complex__actions-list.swiper-container');
	if (cactionSlider) {
		new Swiper(cactionSlider, {
			freeMode: true,
			slidesPerView: 'auto',
			spaceBetween: 10,
		})
	}
});


// leadform
document.addEventListener('DOMContentLoaded', function () {
	
	function removeLeadFormErrors(form) {
		let css = form.querySelector('.has-error');
		if (css) {
			css.classList.remove('has-error');
		}

		let text = form.querySelector('.input-line__error-text:not(.hidden)');
		if (text) {
			text.classList.add('hidden');
		}
	}

	document.addEventListener('click', function(e) {
		const openBtn = e.target.closest('.leadform__open-form-btn');
		if (openBtn) {
			const leadform = openBtn.closest('.leadform');
			leadform.classList.add('leadform--opened');
			const form = leadform.querySelector('.leadform__form');
			form.setAttribute('novalidate', '');

			const hasPreloader = form.querySelector('.preloader');
			if (hasPreloader) {
				// should load form
				fetch('/data/complex/leadform/', {
					method: 'post',
					body: 'info='+openBtn.dataset.info,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
					},
				}).then(response => {
					return response.text();
				}).then(resp => {
					// draw form
					form.innerHTML = resp;
					
					// init selects
					const pickers = form.querySelectorAll('.picker');
					pickers.forEach(picker => {
						pickerObj.rebuildPicker(picker);
					})

					// init mask
					IMask(form.querySelector('[data-input-tel]'), {
						mask: '+{7}(000)000-00-00'
					});
					
				})
				.catch(err => {
					console.log(err);
				});
			}
		}
	});

	document.addEventListener('submit', function(e) {
		const form = e.target.closest('.leadform__form');

		if (form) {
			e.preventDefault();

			removeLeadFormErrors(form);

			const tel = form.querySelector('[data-input-tel]');
			let arr = tel.value.split(''),
					firstDigit = arr[3],
					repeats = 0;
			arr.forEach(function(char){
				if (char == firstDigit) {
					repeats++
				}
			});

			if ( (tel.value.length < 16) || (repeats >= 10) ) {
				const errText = tel.nextElementSibling;
				errText.textContent = tel.dataset.valueInvalid;
				errText.classList.remove('hidden');
				tel.classList.add('has-error');
				return;
			}

			const submitBtn = form.querySelector('.leadform__submit-btn'),
						state = submitBtn.textContent;
			submitBtn.textContent = submitBtn.dataset.wait;
			submitBtn.disabled = true;

			fetch(form.getAttribute('action'), {
				method: 'post',
				credentials: 'include',
				body: new FormData(form)
			}).then(response => {
				return response.json();
			}).then(resp => {

				const dlInput = form.querySelector('.js-data-layer-value');
				if (dlInput && typeof dataLayer != 'undefined') {
					dataLayer.push({
						'event': dlInput.value
					});
				}
				
				form.querySelector('.leadform__form-inner')
					.innerHTML = `<p class="green">Заявка успешно принята. Менеджер свяжется с вами в течение 15 минут.</p>`;

				let rect = form.getBoundingClientRect();
				var elemTop = rect.top;
				if (elemTop < 0) {
					form.scrollIntoView({block: "center", behavior: "smooth"});
				}

				submitBtn.textContent = state;
				submitBtn.disabled = false;
			})
			.catch(err => {
				console.log(err);
				submitBtn.textContent = state;
				submitBtn.disabled = false;
			});
		}

	});

	document.addEventListener('keyup', function(e) {
		const form = e.target.closest('.leadform__form');
		
		if (form) {
			removeLeadFormErrors(form);
		}
	})

	document.addEventListener('change', function(e) {
		const target = e.target;

		if (target.nodeName == 'INPUT') {
			return;
		}

		const selectWrp = target.closest('.leadform__city-region');

		if (selectWrp) {
			const citySelect = selectWrp.querySelector('select');
			
			document.querySelector('.leadform__area--active')
				.classList.remove('leadform__area--active');

			document.querySelector('.leadform__area[data-id="'+ citySelect.value +'"]')
				.classList.add('leadform__area--active');

		}
	});
});